import { useEffect, useRef, useState } from 'react'
import { getDownloader } from './downloaders/registry'

export interface DownloadState {
    link: string | null
    filename: string | null
    error: string | null
}

export function useDownload(
    type: string | undefined,
    id: string | undefined
): DownloadState {
    const [link, setLink] = useState<string | null>(null)
    const [filename, setFilename] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)
    const fetchAttempted = useRef(false)

    const downloader = type ? getDownloader(type) : null

    useEffect(() => {
        if (!downloader || !id) {
            setError('Invalid download link')
            return
        }

        if (fetchAttempted.current) return
        fetchAttempted.current = true

        downloader(id)
            .then((result) => {
                setFilename(result.filename)
                setLink(result.url)
            })
            .catch((err) => {
                setError(err.message || 'Download failed')
            })
    }, [downloader, id])

    return { link, filename, error }
}
